import React from 'react';
import { Faq } from 'components/faq/Faq';
import { FaqItem } from 'components/faq/FaqItem';
import { RichText } from 'components/rich-text/RichText';

export const FaqSlice = ({ title, items, isSlice }) => {
  return (
    <Faq title={title} isSlice={isSlice}>
      {items?.map((item, key) => (
        <FaqItem
          key={key}
          question={RichText.render(item.question)}
          answer={RichText.render(item.answer)}
        />
      ))}
    </Faq>
  );
};

export default FaqSlice;
